module.exports = __webpack_public_path__ + "static/media/PBDQ_Style_Vector.a61b02aa.png";